import { ErrorHandler, inject, Injectable, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from '@core/services/notification.service';
import { LoggerService } from '@core/services/logger.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    private readonly injector = inject(Injector);

    public handleError(error: Error | HttpErrorResponse) {
        // Skip null errors (already handled by interceptor)
        if (!error) {
            return;
        }

        const notificationService = this.injector.get(NotificationService);
        const logger = this.injector.get(LoggerService);

        // Check if this is an HTTP error (which should already be handled by the interceptor)
        if (error instanceof HttpErrorResponse) {
            // HTTP errors are already handled by the interceptor
            // Just log a warning to avoid duplicate notifications
            logger.warn('HTTP Error caught by GlobalErrorHandler (already handled by ErrorInterceptor)', error);
            return;
        }

        // Handle client-side errors
        const message = error.message ? error.message : error.toString();
        notificationService.showError(message);
        logger.error('Uncaught client-side error', error);
    }
}
